import { render, staticRenderFns } from "./_ModalEnviarGeometriaDiagnostico.vue?vue&type=template&id=771594a8&scoped=true&lang=pug"
import script from "./_ModalEnviarGeometriaDiagnostico.vue?vue&type=script&lang=js"
export * from "./_ModalEnviarGeometriaDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./_ModalEnviarGeometriaDiagnostico.vue?vue&type=style&index=0&id=771594a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771594a8",
  null
  
)

export default component.exports